import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "./Use_Current_Location.css";
import Your_Location_modal from "../Your_Location_modal/Your_Location_modal";
import Green_btn from "../../common_btn/green_btn/Green_btn";

function Use_Current_Location(props) {
  const [locationText, setLocationText] = useState("Use Current Location");
  const [isLoading, setIsLoading] = useState(false);
  const [showLocationModal, setShowLocationModal] = useState(false); // State for the "Type manually" modal

  const handleUseCurrentLocation = () => {
    setLocationText("Fetching your location...");
    setIsLoading(true);

    // Use the Geolocation API to get the current location
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // You can use position.coords.latitude and position.coords.longitude
          // to get the user's location if needed
          console.log(position.coords);

          // Set a timeout to close the modal after 3 seconds
          setTimeout(() => {
            props.onHide(); // Close the modal
          }, 3000);

          setIsLoading(false);
        },
        (error) => {
          console.error(error);
          setLocationText("Failed to get location");
          setIsLoading(false);
        }
      );
    } else {
      setLocationText("Geolocation is not supported by this browser.");
      setIsLoading(false);
    }
  };

  const handleShowLocationModal = () => {
    setShowLocationModal(true); // Show the "Type manually" modal
    props.onHide();
  };

  const handleCloseLocationModal = () => {
    setShowLocationModal(false); // Close the "Type manually" modal
  };

   const handleOpenLocationModal = () => {
    setShowLocationModal(true); // Close the "Type manually" modal
  };

  return (
    <>
      <section className="Use_Current_Location">
        <Modal
          {...props}
          size="md"
          centered
          className="Use_Current_Location modal-holder"
          // backdrop="static"
        >
          <Modal.Body>
            <div className="address-text-holder">
              <div className="icon-holder">
                <img
                  className="icon-img"
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/icons/green_location.png"
                  }
                  alt="Location Icon"
                />
              </div>
              <div className="text-holder">
                <p>
                  To get quick delivery, we would like to ensure your currect location
                </p>
              </div>
            </div>

            <div className="footer-btn-holder">
              <div className="text-center btn_holder">
                <Green_btn btnText="Type manually" onClick={handleShowLocationModal} />
                {/* <Button
                  className="submit-btn "
                  type="button"
                  onClick={handleShowLocationModal} // Open the "Type manually" modal
                >
                  Type manually
                </Button> */}
              </div>

              <div className="text-center btn_holder">
                <Button
                  className="use-btn "
                  type="button"
                  onClick={handleUseCurrentLocation}
                  disabled={isLoading} // Disable the button while loading
                >
                  {locationText}
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* Your Location Modal */}
        <Your_Location_modal
          show={showLocationModal}
          onHide={handleCloseLocationModal} 
          onOpen={handleOpenLocationModal} 
          onBackToChooseLocation={handleCloseLocationModal}
          onOpenYourLocation={handleCloseLocationModal}
          setShowConfimLocModal={props?.setShowConfimLocModal}
        />
      </section>
    </>
  );
}

export default Use_Current_Location;
